// extracted by mini-css-extract-plugin
module.exports = {"flex":"Results_flex__2cLD5","results-info":"Results_results-info__262hD"};